import Echo from "laravel-echo";
import Pusher from "pusher-js/with-encryption";

import config from "@/config";
import { axiosClient } from "@/services/client";
import ENDPOINTS from "@/services/endpoints";

type WindowWithEchoAndPusher = Window &
  typeof globalThis & {
    Pusher: typeof Pusher;
    Echo: Echo;
  };

export const windowWithEcho = window as WindowWithEchoAndPusher;

export const establishWebSocketConnection = (): void => {
  windowWithEcho.Pusher = Pusher;

  windowWithEcho.Echo = new Echo({
    broadcaster: "pusher",
    key: config.ablyKey,
    wsHost: "realtime-pusher.ably.io",
    wsPort: 443,
    enableStats: false,
    encrypted: true,
    forceTLS: true,
    activityTimeout: 10000,
    pongTimeout: 10000,
    enabledTransports: ["ws", "wss"],
    cluster: config.pusherCluster,
    authorizer: ({ name }: { name: string }) => ({
      authorize: async (
        socket_id: string,
        callback: (bool: boolean, data: string) => void
      ) => {
        try {
          const response = await axiosClient.post(ENDPOINTS.WEBSOCKET_AUTH, {
            socket_id,
            channel_name: name
          });
          callback(false, response.data);
        } catch (error) {
          callback(true, error as string);
        }
      }
    })
  });
};
